import {
    SetCurrentBoundsAction,
    SetLinkConfirmedAction,
    SET_CURRENT_BOUNDS,
    SET_LINK_CONFIRMED,
    ToggleLinkClickabilityAction,
    TOGGLE_LINK_CLICKABILITY
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const toggleLinkClickability =
    createAction<ToggleLinkClickabilityAction["payload"]>(TOGGLE_LINK_CLICKABILITY);

export const setCurrentBounds = createAction<SetCurrentBoundsAction["payload"]>(SET_CURRENT_BOUNDS);

export const setLinkConfirmed = createAction<SetLinkConfirmedAction["payload"]>(SET_LINK_CONFIRMED);
